import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Components
import Input from "../../components/FormElements/Input";

//
import { loginSchema } from "../../utils/schemas/userSchema";
import UserMiddlewares from "../../store/middlewares/UserMiddlewares";

const LoginForm = () => {
  const dispatch = useDispatch();
  const { isError, errorMessage, isLoading } = useSelector(
    (state) => state.user.login
  );

  const form = useForm({
    resolver: yupResolver(loginSchema),
  });
  const {
    handleSubmit,
    formState: { errors },
  } = form;

  const loginHandler = (data) => {
    dispatch(UserMiddlewares.login(data));
  };

  const { t } = useTranslation();

  return (
    <FormProvider {...form}>
      <div className="form-wrapper my-5">
        <h3 className="mb-3">{t("login.formTitle")}</h3>

        <form onSubmit={handleSubmit(loginHandler)}>
          {isError && <div className="error-message">{errorMessage}</div>}
          <div className="mb-2">
            <Input
              id="email"
              name="email"
              placeholder={t("login.emailPlaceholder")}
              label={t("login.emailLabel")}
              error={errors?.email?.message}
            />
          </div>
          <div className="mb-2">
            <Input
              id="password"
              name="password"
              placeholder={t("login.passwordPlaceholder")}
              label={t("login.passwordLabel")}
              error={errors?.password?.message}
              type="password"
            />
          </div>
          <div className="d-grid gap-2 my-3">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading
                ? t("login.loginButtonLoading")
                : t("login.loginButton")}
            </button>
          </div>
        </form>

        <p className="text-center mb-0">
          {t("login.notMember")}{" "}
          <Link to="/signup">{t("login.signupLink")}</Link>
        </p>
      </div>
    </FormProvider>
  );
};

export default LoginForm;
